<template>
  <div id="app" class="app-shell">
    <AppSidebar :is-open="isSidebarOpen" @close="closeSidebar" />

    <button class="mobile-menu-btn" @click="toggleSidebar" aria-label="Buka menu navigasi">
      Menu
    </button>

    <div v-if="isSidebarOpen" class="mobile-overlay" @click="closeSidebar"></div>

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import AppSidebar from './components/AppSidebar.vue'

export default {
  name: 'App',
  components: {
    AppSidebar
  },
  data() {
    return {
      isSidebarOpen: false
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen
    },
    closeSidebar() {
      this.isSidebarOpen = false
    }
  }
}
</script>

<style>
:root {
  --sidebar-width: 280px;
  --font-body: "Plus Jakarta Sans", "Segoe UI", "Helvetica Neue", sans-serif;
  --font-heading: "Merriweather", Georgia, serif;
}

* {
  box-sizing: border-box;
}

body {
  font-family: var(--font-body);
  margin: 0;
  padding: 0;
  background: #fff9ed;
  color: #2f1f12;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-heading);
  letter-spacing: 0.01em;
}

button,
input,
select,
textarea {
  font: inherit;
}

.app-shell {
  display: flex;
  min-height: 100vh;
  position: relative;
}

.main-content {
  flex: 1;
  width: 100%;
  margin-left: var(--sidebar-width);
  min-width: 0;
  transition: margin-left 0.25s ease;
}

.mobile-menu-btn {
  display: none;
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1201;
  border: 1px solid #d6a466;
  border-radius: 999px;
  background: linear-gradient(125deg, #ffd89b, #ffefcf);
  color: #6f3e06;
  font-weight: 700;
  padding: 10px 16px;
  box-shadow: 0 8px 18px rgba(111, 62, 6, 0.25);
  cursor: pointer;
}

.mobile-overlay {
  display: none;
}

@media (max-width: 960px) {
  .main-content {
    margin-left: 0;
  }

  .mobile-menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-overlay {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(33, 23, 14, 0.45);
    z-index: 1100;
  }
}
</style>
